import { render, staticRenderFns } from "./loseClient.vue?vue&type=template&id=6fb4c1a2&scoped=true&"
import script from "./loseClient.vue?vue&type=script&lang=js&"
export * from "./loseClient.vue?vue&type=script&lang=js&"
import style0 from "./loseClient.vue?vue&type=style&index=0&id=6fb4c1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb4c1a2",
  null
  
)

export default component.exports